declare global {
  interface Window {
    Intercom?: Intercom
  }
}

import Intercom from './lib'

import type { Plugin } from 'vue'
import { ref } from 'vue'

const intercomInstalled = false

const install: Plugin['install'] = (app, options = {}) => {
  const { appId } = options

  if (!appId) {
    console.warn('You did not provide Intercom appId. Please check your configuration.')
    return
  }

  const intercom = new Intercom(appId)
  if (intercomInstalled) {
    return
  }

  const appProp = { intercom, visible: ref(false) }
  intercom.on('show', () => (appProp.visible.value = true))
  intercom.on('hide', () => (appProp.visible.value = false))

  app.config.globalProperties.$intercom = appProp

  if (typeof window.Intercom !== 'function') {
    const placeholder = (...args: unknown[]): unknown => placeholder.c(args)
    const q: unknown[][] = []
    placeholder.c = (args: unknown[]): unknown => q.push(args)
    placeholder.q = q
    window.Intercom = placeholder as unknown as Intercom
  }

  intercom.init()
  intercom.callIntercom('reattach_activator')
  intercom.update()
}

export { Intercom }

export const plugin: Plugin = { install }
